import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LanguageContext } from "./LanguageContext";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import Survey from "./pages/Survay";
import Loading from "./pages/Loading";
import Result from "./pages/Result";

const App = () => {
  const [language, setLanguage] = useState("ko");
  const toggleLanguage = () =>
    setLanguage((prev) => (prev === "ko" ? "en" : "ko"));

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      <Router>
        <Routes>
          <Route path="/"       element={<Layout><Home    /></Layout>} />
          <Route path="/survey" element={<Layout><Survey  /></Layout>} />
          <Route path="/loading"element={<Layout><Loading /></Layout>} />
          <Route path="/result" element={<Layout><Result  /></Layout>} />
        </Routes>
      </Router>
    </LanguageContext.Provider>
  );
};

export default App;
